import { SelectOption } from "../../../../../../shared/interfaces";
import { InsuredList } from "../../../../../../shared/interfaces/services/enrollment-and-termination-document-request";
import { buildInsuredTable } from "./buildInsuredTable";

export function buildEmailBody(
  beneficiaryName: string,
  beneficiaryDocument: string,
  insuredOfPolicy: InsuredList[],
  insuredDeleteds: InsuredList[],
  insuredLoaded: InsuredList[],
  apActiviesListOptions: SelectOption[]
) {
  const beneficiarySection = `<h3>Beneficiario</h3> En primer Termino: ${beneficiaryName}, CUIT: ${beneficiaryDocument}, en tanto el eventual siniestro haya ocurrido mientras el asegurado se encuentre al servicio de la misma, cumpliendo tareas inherentes a la pertinente contratacin y/o en circustancias que le generen responsabilidad. <br>
                              Los contenidos de este mensaje, y los archivos adjuntos, son de carácter confidencial. Si Ud. no es el legitimo destinatario de este mensaje, avise inmediatamente al remitente y borre este mensaje. Cualquier distribución o divulgación no autorizada de este mensaje y sus archivos asociados está prohibida. Por favor infórmenos inmediatamente y destruya el original o cualquier impresión del mismo.`;
  const bodyEmail = [
    buildInsuredTable("Asegurados", insuredOfPolicy, apActiviesListOptions),
    buildInsuredTable("Bajas", insuredDeleteds, apActiviesListOptions),
    buildInsuredTable("Altas", insuredLoaded, apActiviesListOptions),
  ]
    .join("<br/>")
    .concat(beneficiarySection);

  return bodyEmail;
}